const updateOrderDate = () => {
    checkCart();
    const rawDate = document.querySelector('.item_delivery_date')?.innerHTML.trim();
    if(!rawDate){
        return;
    }
    var date = new Date(rawDate);   
    if (!(date.toDateString() === new Date().toDateString())) {
        date.setDate(date.getDate() - 1);
    }
    const formattedDate = date.toLocaleDateString('en-GB', {   
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
        });
    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            attributes: { "Delivery Date": formattedDate }
        })
    });
};
const observeCart = () => {
    const cartIcon = document.querySelector(".header__icon--cart");
    if (!cartIcon) return;
    new MutationObserver(() => updateOrderDate()).observe(cartIcon, { childList: true, subtree: true, characterData: true, attributes: true });
};
const waitForCartParent = setInterval(() => {
    if (document.querySelector(".header__icon--cart")) {
        clearInterval(waitForCartParent);
        observeCart();
    }
}, 500);
const checkCart = () => {
    const cartDates = Array.from(document.querySelectorAll('.item_delivery_date'));
    const dateWarnings = document.querySelectorAll('.date-warning'); 
    if (!cartDates.length) return;
    const checkoutButtons = document.querySelectorAll('.cart__checkout-button');
    const dynamicCheckout = document.querySelector('.dynamic-checkout__content');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const hasPastDate = cartDates.some(el => {
        const itemDate = new Date(el.textContent.trim());
        itemDate.setHours(0, 0, 0, 0);
        return itemDate < today;
    });
    if (hasPastDate) {
        checkoutButtons.forEach(btn => {
            btn.disabled = true;
            btn.style.opacity = '50%';
            btn.style.cursor = 'not-allowed';
            btn.style.pointerEvents = "none";
        });
        if (dynamicCheckout) {
            dynamicCheckout.style.pointerEvents = 'none';
            dynamicCheckout.style.opacity = '50%';
            dynamicCheckout.style.position = 'relative';
        }
        dateWarnings.forEach(warning => warning.style.display = 'flex');
    } else {
        checkoutButtons.forEach(btn => {
            btn.disabled = false;
            btn.style.opacity = '100%';
            btn.style.cursor = 'pointer';
            btn.style.pointerEvents = "auto";
        });
        if (dynamicCheckout) {
            dynamicCheckout.style.pointerEvents = 'auto';
            dynamicCheckout.style.opacity = '100%';
        }
        dateWarnings.forEach(warning => warning.style.display = 'none');
    }
};
document.addEventListener('DOMContentLoaded', checkCart);